import {
	Avatar,
	Box,
	Card,
	CardContent,
	CardHeader,
	CardMedia,
	IconButton,
	Typography,
	Grid,
	Button,
	Chip,
	DialogContent,
	Dialog,
	DialogTitle,
	DialogContentText,
	DialogActions
} from "@mui/material";
import { blue, green, grey, red, yellow } from "@mui/material/colors";
import makeStyles from '@mui/styles/makeStyles';
import CreateIcon from "@mui/icons-material/Create";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import Collapse from '@mui/material/Collapse';
import {
	Calendar,
	Check,
	FrameGreen,
	FrameYellow,
	FrameBlue,
	FrameRed,
	ArrowLeft,
	CloseDialog,
} from '../resources'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';

import {PullToRefresh, PullDownContent, ReleaseContent, RefreshContent} from "react-js-pull-to-refresh";
import moment, { Moment } from "moment";
import React, { useEffect, useRef } from "react";
import ReactPlayer from 'react-player'
import { useSelector } from "react-redux";
import { Link as RouterLink, useParams, useLocation, useNavigate } from "react-router-dom";
import { Loading } from "../components";
import { RootState } from "../reducers";
import { updateVisitActivity, updateVisit, getVisitById } from "../services/api";

import CompletionDialog from "../components/CompletionDialog";


import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';


import "moment/locale/fi"
import "moment/locale/de"
import "moment/locale/fr"
import "moment/locale/zh-cn"
import "moment/locale/zh-tw"

const useStyles = makeStyles((theme) => ({
	root: {
		minWidth: 275,
		// marginBottom: "1rem",
		// marginTop: "1rem",
		background: 'white',
		position: "sticky",
        top: 0,
        bottom: 20, 
	},
	bullet: {
		display: "inline-block",
		margin: "0 2px",
		transform: "scale(0.8)",
	},
	backButton: {
		margin: "1rem",
	},
	media: {
		// height: 240,
		backgroundSize: "contain",		
	},
	pos: {
		display: "flex",
		justifyContent: "flex-end",
		marginBottom: 12,
	},
	statusOver: {
		backgroundColor: blue[200],
	},
	statusNot: {
		backgroundColor: "white",
	},
	statusUnder: {
		backgroundColor: "#FFDA17",
	},
	statusFully: {
		
		backgroundColor: green[200],
	},
	statusStarted: {
		color: "black",
		backgroundColor: yellow[200],
	},
	titleContainer: {
		display: "flex",
		width: "100%",
		flexDirection: "row",
		alignItems: "center",
		alignContent: "center",
		height: "54px",
		backgroundColor: "#8fd400",
		justifyContent: "center",
		marginTop: "0px",

	},
	title: {
		fontSize: 32,
		fontWeight: "normal",
		color: "white",
		marginBottom: "0px"
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
		  duration: theme.transitions.duration.shortest,
		}),
		padding: "6px 0px",
		minWidth: 0,
	},
	expandOpen: {
		transform: 'rotate(180deg)',
	},
	instruction: {
		color: "darkgreen",
		marginBottom: 0
	},
	description: {
	},
	fullHeightCard: {

	},
	endSessionButton: {	
		minWidth: "114px",
		whiteSpace: "nowrap",
		height: 36,
		textTransform: "none",
		borderRadius: "99px",
		color: "#404040",
		boxShadow: "0 2px 2px #404040",
		backgroundColor: "#F28986",
		"&:hover": {
			backgroundColor: "#F28986",
		},
	},
	dialogTitle: {
		color: "#404040",
		width: "100%",
		alignItems: "center",
		textAlign: "center",
		justifyContent: "center",
		fontSize: "16px",
		fontWeight: 600,
		flex: 1,
		whiteSpace: "normal",
		textOverflow: "ellipsis",
		paddingRight: 0,
	},
	activityCards: {
		borderRadius: "15px",
		
	},
	arrowButton: {        
        height: "40px",               
        borderRadius: "14px",
        background: "#F7F8F8",
        marginRight: "54px",
        marginLeft: "10px"
    },
	
	}));
const StyledPaper = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
	...theme.typography.body1,
	padding: theme.spacing(2),

	color: theme.palette.text.primary,
	}));
// duration for timer
function timeSinceStart(login : Moment, logout: Moment){
	let _duration = "AAAA";

	console.log(_duration);
    return true;

};
let interval;
export function TrainingSessionDetailsPage(props) {
	const classes = useStyles();
	const { t, i18n } = useTranslation();	
	const location = useLocation();
	const navigate = useNavigate();
	const availableActivities = useSelector((state: RootState) => {
		return state.activities;
	});
	let { id } = useParams<{id:string}>();
	const [visit, setVisit] = React.useState(null);
	const [loading, setLoading] = React.useState(false);
	const [updatingActivity, setUpdatingActivity] = React.useState(false);
	const [updatingActivityId, setUpdatingActivityId] = React.useState(null);
	const [expanded, setExpanded] = React.useState([]);
	const [message, setMessage] = React.useState(null); // for Snapbar
	const [openDialog, setOpenDialog] = React.useState(false);
	const [openCompletionDialog, setOpenCompletionDialog] = React.useState(false);
	const [_numberOfActivities, _setNumberOfActivities] = React.useState(0);
	const [_numberOfPerformedActivities, _setNumberOfPerformedActivities] = React.useState(0);	
	const [hasSeenCompletionDialog, setHasSeenCompletionDialog] = React.useState(() => {
		return localStorage.getItem('hasSeenCompletionDialog') === 'true' || false;
	});
	const [previousStatuses, setPreviousStatuses] = React.useState(() => {
		const storedSatutes = localStorage.getItem('previousStatuses');
		return storedSatutes ? JSON.parse(storedSatutes) : [];
	});
	const [isTop, setIsTop] = React.useState(true);
		
    useEffect(() => {
        if (visit) {
            const activities = visit.activities;
            _setNumberOfActivities(activities.length);
            
            let performedCount = 0;
            for (const activity of activities) {
                if (activity.status !== 'N') {
                    performedCount++;
                }
            }
            _setNumberOfPerformedActivities(performedCount);

			const currentStatuses = activities.map(activity => activity.status);
			console.log("currentStatutes", currentStatuses)
			if(JSON.stringify(currentStatuses) !== JSON.stringify(previousStatuses)) {
				setHasSeenCompletionDialog(false);
				localStorage.setItem('hasSeenCompletionDialog', 'false');
				setPreviousStatuses(currentStatuses);
				localStorage.setItem('previousStatuses', JSON.stringify(currentStatuses));
			}
        }
    }, [visit, previousStatuses]);
	
	// set language
	moment.locale(i18n.language);

	const handleExpandClick = (idx: number) => {
		let _expanded = [...expanded]
		
		_expanded[idx] = !_expanded[idx]
		setExpanded(_expanded);
	};
	const handleCloseMessage = () => {
		setMessage(null);
	};

	const handleGoBack = () => {
		navigate(-1)
	}

	const handleRefresh = async () => {			
		window.location.reload();	
}

	const handleOpenDialog = () => {
		setOpenDialog(true);
	}

	const handleCloseDialog = () => {
		setOpenDialog(false);
	}

	const handleOpenCompletionDialog = () => {
		setOpenCompletionDialog(true);
		setHasSeenCompletionDialog(true);
	}

	const handleCloseCompletionDialog = () => {		
		setOpenCompletionDialog(false);		
	}

	const [timeElapsed, setTimeElapsed] = React.useState("");

	const  endSession = async () => {

		try {
			// remove activities from payload
			const {activities, ...uploadVisitData} = visit;
			// fill in logout
			uploadVisitData.logout = moment().toISOString();
			const updatedVisit = await updateVisit(
				parseInt(visit.id, 10),
				uploadVisitData
			);
			setVisit(updatedVisit);
			setMessage("Session ended.");
			setTimeElapsed("");
			clearInterval(interval);			
		} catch (e) {
			console.log(e);
		}		
	}

	useEffect(() => {
		console.log("useEffect");
		async function initData() {
			setLoading(true);
			try {
				const visitResponse = await getVisitById(parseInt(id, 10));
				// filter visit activities by created id
				if(visitResponse.activities){
					visitResponse.activities.sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
				}
				setVisit(visitResponse);
				
				if(!visitResponse.logout){
					// inital
					setTimeElapsed( te => {
						const dur = moment.duration( moment().diff(moment(visitResponse.login)) );
						return ("0"+dur.hours()).substr(-2) + ":" + ("0"+dur.minutes()).substr(-2) + ":" + ("0"+dur.seconds()).substr(-2);
					});
                    // timer
					interval = setInterval(() => {
						setTimeElapsed( te => {
							const dur = moment.duration( moment().diff(moment(visitResponse.login)) );
							return ("0"+dur.hours()).substr(-2) + ":" + ("0"+dur.minutes()).substr(-2) + ":" + ("0"+dur.seconds()).substr(-2);
						});
					}, 1000);
				};
				// expand activities in view - state
				let _expand_false_all = visitResponse.activities.map(() => { return false;});
				
				setExpanded(_expand_false_all);

			} catch (e) {
				console.log(e);
			}
			setLoading(false);

		}
		initData();

		return () => {
			console.log("clearinterval");
			clearInterval(interval);
		};
	}, [id]);	

		const onStatusUpdate = async (activity_id: string, update: any) => {
			setUpdatingActivity(true);
			setUpdatingActivityId( parseInt(activity_id, 10) );
			let activity:object = {};

			try {
				const updatedActivity = await updateVisitActivity(
					parseInt(activity_id, 10),
					Object.assign({}, activity, update)
				);
				//setActivity(updatedActivity);
				//setMessage("Your activity has been updated successfully");
				setHasSeenCompletionDialog(false);
			} catch (e) {
				console.log(e);
			}
			setUpdatingActivity(false);
			setUpdatingActivityId(null);
		};

		const saveActivityAsFullyPerformed = (activity_id: string) => {
			// alert(activity_id);
			// console.log("ssss");
			let _activity = null;
			for (const activity of visit.activities) {
				if(activity.id === activity_id){
					_activity = activity;
				}
			}
			// modify _activity
			const activityDetails = availableActivities.find(
				(availableActivity) => {
					return availableActivity.id === _activity.activity;
				}
			);
			const activity_type = activityDetails.all_activity.activity_type;

			_activity["status"] = "F";
			_activity["results"] = null;

			_activity["start_time"] = moment()
			_activity["end_time"] = moment()

			if([1, 3, 7, 8, 9, 56].includes(activity_type) ){
				_activity["results"] = _activity['settings'];
			}


			// TODO add results relating to different activities' types

			onStatusUpdate(activity_id, _activity);			
		};

		  useEffect(() => {
		if(visit && !visit.logout && visit.visit_type === 4) {
        if (_numberOfPerformedActivities > 0 && _numberOfPerformedActivities === _numberOfActivities && !hasSeenCompletionDialog) {
			console.log("hasSeenCompletionDialog on useEffect", hasSeenCompletionDialog)
            setOpenCompletionDialog(true);
			setHasSeenCompletionDialog(true);
			localStorage.setItem('hasSeenCompletionDialog', 'true');
        }
	}
    }, [_numberOfPerformedActivities, _numberOfActivities, hasSeenCompletionDialog]);	
	
	const getStatusClass = (status: string) => {
		switch (status) {
			case "O":
				return classes.statusOver;
			case "N":
				return classes.statusNot;
			case "U":
				return classes.statusUnder;
			case "F":
				return classes.statusFully;
			case "S":
				return classes.statusStarted;
		}
		return "";
	};
	const getStatusName = (status: string) => {
		switch (status) {
			case "O":
				return "Over Performed";
			case "N":
				return "Not Performed";
			case "U":
				return "Under Performed";
			case "F":
				return "Fully Performed";
			case "S":
				return "Started";
		}
		return "Unknown";
	};		
	const getStatusColor = (status: string) => {
		switch (status) {
			case "O":
				return blue[500];
			case "N":
				return grey[500];
			case "U":
				return red[500];
			case "F":
				return  green[500];
			case "S":
				return yellow[500];
		}
		return grey[100];
	};


	if (loading || !visit) {
		console.log("Loading");
		return <Loading />;
	}

	// interval = setInterval(() => {
	// 	if(visit){
	// 		timeSinceStart(moment(visit.login), moment(visit.logout));
	// 	}
	// 	console.log("Here.");
	// }, 1000);

	const visitStart = moment(visit.login);
	let duration = "";
	

	if (visit.logout) {
		const visitEnd = moment(visit.logout);
		duration = moment.duration(visitEnd.diff(visitStart)).humanize();
	}



	const title = `${t('training_session_page.duration', {duration: duration})}`;
	const date = `${visitStart.format("dddd, MMMM D, YYYY")}`
	const serverUrl = localStorage.getItem("server_url");
	const activities = [];
	let numberOfPerformedActivities=0, numberOfActivities=visit.activities.length;		
	for (const [act_index, activity] of visit.activities.entries() ) {
		const activityDetails = availableActivities.find(
			(availableActivity) => {
				return availableActivity.id === activity.activity;
			}
		);
		const image =
			activityDetails.picture && activityDetails.picture.length > 1
				? activityDetails.picture
				: activityDetails.all_activity.picture;
		const imageFallback = "activity_images/freetrainer_HPEmzfT.png"; // fallback to freetrainer image
		// use cdn
		const cdnAddress = "https://cdn01.hursmarttouch.com"; //"https://d3ldm7xf6jmsyw.cloudfront.net";
		const imageUrl = `${image}`.startsWith('activity_images') ? `${cdnAddress}/media/${image}` : `${serverUrl}media/${image}`;
		
		const imageFallbackUrl = `${serverUrl}media/${imageFallback}`;
		let animation =
			activityDetails.animation && activityDetails.animation.length > 1
				? activityDetails.animation
				: (activityDetails.all_activity.animation && activityDetails.all_activity.animation.length > 1 ? activityDetails.all_activity.animation: null);
		animation = animation ? `${serverUrl}media/${animation}` : animation;
		
		let video =
			activityDetails.video && activityDetails.video.length > 1
				? activityDetails.video
				: (activityDetails.all_activity.video && activityDetails.all_activity.video.length > 1 ? activityDetails.all_activity.video: null);

		const onMediaFallback = (event) => {
			event.target.src = imageFallbackUrl;
			//console.log("onMediaFallback-imageFallbackUrl", imageFallbackUrl);
		};
		const activityId = `/app/workouts/${visit.id}/activity/${activity.id}`;
		// is performed
		if(activity.status != 'N') numberOfPerformedActivities++;			

		// description and comments		
		let description = null;
		let comments = null;
		if(activityDetails?.description){
			description = activityDetails.description;
		}else{
			if( !([56].includes(activityDetails.all_activity.activity_type)) && activityDetails.all_activity?.description ){
				description = activityDetails.all_activity.description;
			}

		}
		if(activityDetails?.comments){
			comments = activityDetails.comments;
		}
		// instruction		
		let instruction = null;
		if(activity?.instruction){
			instruction = activity.instruction;
		}
		// hur activity
		if( activityDetails.all_activity.activity_type === 1 ){
			comments = "This exercise should be performed on HUR machine." 
		}

		let results = null;
		let settings = activity.settings;
		if (activity?.settings?.parameters) {
			if (activity.results && typeof activity.results === "object") {
				results = activity.results;
			} else {
				results = activity.settings.parameters;
			}
		} else {
			if (activity.results && typeof activity.results === "object") {
				results = activity.results;
			} 
		}

		const activityType = activityDetails.all_activity.activity_type;
		let parameters = [];

		if (settings && activityType === 7) {
			parameters = [
				<div key="time">
					<b>Time (min): </b>
					{settings.time}
				</div>,
			];
		}
		if (settings && activityType === 8) {
			parameters = [
				<div key="performances-8">
					<b>Performances: </b>
					{settings.performances}
				</div>,
			];
		}
		if (settings && activityType === 9) {
			const load = (activity.settings.init_load / 1000).toFixed(0);
			parameters = [
				<div key="performances-9">
					 {load} kg x {settings.performances}
				</div>,
			];
		}
		const statusClass = getStatusClass(activity.status);
		if (activityType === 56 && Array.isArray(settings.parameters)) {
			parameters = settings.parameters.map((result, idx: number) => {
				if (result.type === "integer") {
					return (
						<div key={idx}>
							<b>{result.name}: </b>
							{result.value}
						</div>
					);
				}
				if (result.type === "float") {
					return (
						<div key={idx}>
							<b>{result.name}: </b>
							{result.value}
						</div>
					);
				}
				if (result.type === "time") {

					let _min = "", _sec = "";
					let result_string;
					if (result.unit === "min") {
						const m = Math.floor(result.value);
						_min = m.toString();
						result_string = `${_min} ` + "min";
					}
					if (result.unit === "sec") {
						const s = result.value
						_sec = s.toString();;
						result_string = `${_sec} ` + "sec";
					}
					if (result.unit === "min_sec") { 
						const m = Math.floor(result.value / 60);
						const s = result.value % 60;
						_min = m < 10 ? `0${m}`: `${m}`;
						_sec = s < 10 ? `0${s}`: `${s}`;
						result_string = `${_min + ":" + _sec} ` + "(mm:ss)";
					}


					return (
						<div key={idx}>
							<b>{result.name}: </b>
							{result_string}
						</div>
					);
				}
				return (
					<div key={idx}>
						<b>{result.name}: </b>
						{result.value}
					</div>
				);
			});
		}
		// hur activity
		if (activityType === 1 && "sets" in settings  && Array.isArray(settings.sets)) {
			parameters = settings.sets.map((set, idx: number) => {
				//const unit = "units" in results && results.unit = "lbs" - TODO
				//const load = results
				// check if there are results
				if (results && "sets" in results  && Array.isArray(results.sets) && results.sets.length > idx ){
					return (
						<Typography variant="body2" key={idx}>
								{idx+1}. {results.sets[idx].load/1000.} <sup>(/{set.load/1000.})</sup> kg x {results.sets[idx].reps} <sup>(/{set.reps})</sup> reps
						</Typography>
					)
				} else{
					return (
						<Typography variant="body2" key={idx}>
								{idx+1}. {set.load/1000.} kg x {set.reps} reps
						</Typography>
					)
				}
			});
			//console.log("Hur Activity results", results);
			parameters = [ <div><b>Sets</b></div>, ...parameters];
		}		
		let activityAction = null;
		if (!visit.logout) {
			activityAction = (
				<div >
					{updatingActivity && updatingActivityId === activity.id && (<CircularProgress color="primary"/>)}
					
					{activity.status ==='N' && ([3, 7, 8, 9, 56].includes(activityType)) && updatingActivityId != activity.id &&
					
						<IconButton
                            aria-label="perform"
                            onClick={() => { saveActivityAsFullyPerformed( activity.id ) }}
                            size="large">
							<CheckCircleIcon style={{ fontSize: 38}} />
						</IconButton>
					}
					{activity.status !=='N' && ([3, 7, 8, 9, 56].includes(activityType)) && updatingActivityId != activity.id &&
					<IconButton aria-label="update" component={RouterLink} to={activityId} size="large">
						<CreateIcon style={{ fontSize: 38}} />
					</IconButton>
					}
				</div>
			);


		}
		activities.push(
			
			<StyledPaper key={activity.id}
				sx={{
				my: 0,
				mx: 0,
				p: 0,
				maxWidth: '100%',
				minWidth: '100%',
				borderRadius: "15px",
				boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
				}}
			>
				{/* <CardHeader
					action={activityAction}
					title={activity.activity_name}
				/> */}

					<Grid display="flex" flexDirection="column" alignItems="center" justifyContent="center" textAlign="center"
						component={RouterLink} to={ !visit.logout ? `${activityId}?e=1` : activityId} style={{ textDecoration: 'none', color: "black" }}>
						<Box sx={{borderBottom: '1px solid #7B6F72', height: '100%', display: 'flex', justifyContent: 'center'}}>							
						<Grid item xs={7}>
							<CardMedia
								className={classes.media}								
								image={imageUrl}
								component="img"
								onError={onMediaFallback}
								title={activity.activity_name}
								
							/>
						</Grid>
						{statusClass === classes.statusFully ? (
						<FrameGreen style={{display: 'flex', justifyContent: 'flex-end'}}/>
						) : statusClass === classes.statusOver ? (
						<FrameBlue style={{display: 'flex', justifyContent:'flex-end'}}/>
						) : statusClass === classes.statusUnder ? (
						<FrameYellow style={{display: 'flex', justifyContent: 'flex-end'}} />
						) : (
						<Check style={{display: 'flex', justifyContent: 'flex-end'}}/>
						
						)}
						</Box>																		
						<div style={{display: 'flex', flexDirection: 'column'}}>						
						<Typography sx={{color: '#7B6F72'}}>{activity.activity_name}</Typography>													
						</div>	
						{/* <Grid >
							<IconButton component={RouterLink} to={ !visit.logout ? `${activityId}?e=1` : activityId} size="large">
								<ArrowForwardIosIcon style={{ fontSize: 18}} />
							</IconButton>
						</Grid> */}
						{/* {instruction && (<Grid item xs={12}>
							<Typography className={classes.instruction} paragraph>{instruction}</Typography>
							</Grid>)
						} */}
					
					</Grid>


				<Collapse in={expanded[act_index]} timeout="auto" unmountOnExit>
					<div>
					<Typography variant="h6">Description</Typography>
					<Typography paragraph>
						{description}
					</Typography>
					{comments && 
						(<div><Typography variant="h6">Comments</Typography>
						<Typography paragraph>
							{comments}
						</Typography></div>)
					}				
					{/* for videos */}
					{video &&
						(<div><Typography variant="h6">Video</Typography>
							<div className="player-wrapper" style={{ position: "relative", paddingTop: "56.25%" }}>
								<ReactPlayer id="video-player" ref={ref} url={video} controls={true}
									width="100%" height="100%" muted={false} style={{ position: "absolute", top: 0, left: 0 }} onEnded={loop_video} onProgress={handleProgress}/>
							</div>
						 </div>)
					}
					{/* for pictures like */}
					{animation  && ["jpg", "jpeg", "gif", "png"].includes( animation.split('.').pop()) &&
						(<div><Typography variant="h6">Animation</Typography>
							<div className="player-wrapper" style={{ textAlign: "center" }}>
								<img src={animation} 
									style={{  }} />
							</div>
						 </div>)
					}
					</div>
				</Collapse>



			</StyledPaper>
		);	

	}		
	// console.log("visit", visit);
	// console.log("number of activities", numberOfActivities)
	
	
	
	
	var this_player:any;

	function loop_video(){
		//let this_player = document.getElementById("video-player");
		this_player.playing = true;
		this_player.seekTo(66, 'seconds');
		
		console.log("loop");

	}

	function handleProgress(state){
		//console.log('onProgress', state);
		//console.log('this_player', this_player);
		// if(state['playedSeconds']>72){
			
		// 	this_player.seekTo(67, 'seconds');
		// 	this_player.playing = true;

		// }


	  }

	function ref(player){
		this_player = player;
	}
	function SlideTransition(props) {
		return <Slide {...props} direction="up" />;
	}

	const handleEndSessionClick = () => {
		if(numberOfPerformedActivities < numberOfActivities) {
			setOpenDialog(true);
		} else {
			endSession();
			navigate('/app/startworkout')
		}
	}
	const handleConfirmEndSession = () => {
		endSession();
		navigate('/app/startworkout');
		setOpenDialog(false);
	}	


	
	
	// console.log("activities", activities)

	

	return (								
		<div style={{ marginBottom: "4px", paddingTop: "160px", overflowX: "initial"}}>		
		<CompletionDialog 
			open={openCompletionDialog}
			handleCloseDialog={handleCloseCompletionDialog}
			endSession={endSession}
		/>				
			<Card  variant="outlined" style={{ top: 0, width: "100%", overflowX: "initial", position: "fixed", zIndex: 100, backgroundColor: "white"}}>			
				<CardContent>
					<Typography 
						variant="h6"
						component="h2" 
						style={{
							padding: "1vh 3vw 0vh 3vw",
							fontSize:"calc(0.875rem + 0.5vw)",
						color:"#404040",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis",
							}}
							>
					<Button onClick={() => navigate('/app/dashboard')} ><ArrowLeft style={{marginRight: "54px"}}/></Button>
						{visit?.training_program_name ?? "-"}
					</Typography>
					<Typography className={classes.pos} color="#404040" fontSize="0.875rem" fontWeight={400}>
						<Calendar style={{marginRight: 10}}/>
						{date}
					</Typography>
					<div style={{ display:'flex', alignItems: 'center', justifyContent: 'space-between', lineHeight: 1}}>
						<div>
					<Typography style={{fontSize: "0.875rem", color:"#404040"}}>
						{ t('training_session_page.activities_performed_other', { count: numberOfPerformedActivities, numberOfActivities: numberOfActivities }) } &nbsp;
					</Typography>
					<Typography style={{
						fontSize:"0.875rem",
						color:"#404040",						
						}}
						>
						{title}				
						{timeElapsed}
						</Typography>
						</div>										
						<div>
						{!visit.logout && 
							(<Button className={classes.endSessionButton}
								onClick={handleEndSessionClick}
							 >
							 {t('training_session_page.end_session')}
							 </Button>	
							)
						}																						
					   </div>																
					</div>				
					<Dialog
						open={openDialog}
						onClose={handleCloseDialog}
						PaperProps={{
							style:{
								border: "1px solid black",
								borderRadius: "16px"
							}
						}}
						>
							<div style={{
								display: "flex", 
								flexWrap: "wrap", 
								justifyContent: "space-between", 
								alignItems: "center", 
								width: "100%"
								}}
								>
						<DialogTitle className={classes.dialogTitle}>{t('training_session_page.dialog_title')}</DialogTitle>
						<IconButton
							onClick={handleCloseDialog}
							style={{
								paddingRight: 10,
								flexShrink: 0,
							}}>
								<CloseDialog />
							</IconButton>				
							</div>
							<DialogContent style={{paddingTop: 0, paddingBottom: 0, textAlign: "center"}}>
								<DialogContentText style={{color: "#1D1617", fontSize: "14px", fontFamily: "Poppins"}}>{t('training_session_page.dialog_text')}</DialogContentText>
								</DialogContent>		
						<DialogActions>
							<div style={{display: "flex", justifyContent: "center", alignItems: "center", width: "100%", paddingBottom: "10px"}}>
							<Button className={classes.endSessionButton} onClick={handleConfirmEndSession}>{t('training_session_page.end_session')}</Button>
							</div>							
							</DialogActions>				
						</Dialog>			
				</CardContent>
			</Card>			
			<div style={{minHeight: "1000px", overflow: "scroll", overflowX: "hidden" }}>
		{!visit.logout ? (
			<PullToRefresh
		pullDownContent={<PullDownContent />}
		releaseContent={<ReleaseContent />}
		refreshContent={<RefreshContent />}
		pullDownThreshold={300}
		onRefresh={handleRefresh}
		triggerHeight={400}
		backgroundColor="white"
		startInvisible={true}
	>
			<Grid container spacing={2} style={{ padding:16}}>
				{activities.map((activity, index) => (
					<Grid item key={index} xs={6} sm={6} md={4} lg={3}>{activity}</Grid>
				))}			

			{message && <Snackbar
				open={!!message}
				autoHideDuration={3000}
				onClose={handleCloseMessage}
				TransitionComponent={SlideTransition}
				sx={{ bottom: { xs: 60, sm: 0 } }}
			>
				<Alert severity="success">
					{message}
				</Alert>
			</Snackbar>
			}			
			</Grid>
			<Grid container spacing={1} style={{ padding:16, margin:30 }}></Grid>				
			</PullToRefresh>	
			) : (
				<div style={{minHeight: "1000px", overflow: "scroll", overflowX: "hidden" }}>
				<Grid container spacing={2} style={{ padding:16}}>
				{activities.map((activity, index) => (
					<Grid item key={index} xs={6} sm={6} md={4} lg={3}>{activity}</Grid>
				))}	
				</Grid>
				<Grid container spacing={1} style={{ padding:16, margin:30 }}></Grid>
				</div>
		)}
		</div>
			</div>			
			
	);
}
